import { useEffect, useState } from 'react';

import { parseQueryString, parseAmplifyConfig } from '@warden-ui/common';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CupixWorksApi } from "@warden-ui/api";
import { cloneSearchParams, isEmailFormat } from '@warden-ui/common';
import { CardContentTeamFindSent } from '@warden-ui/card-components';
import { CPPageBody } from '@warden-ui/common-components';
import { useTranslation } from 'react-i18next';

const defaultQueryString: { [key: string]: string } = {
  config: '',
  region: '',
  email: '',
  team_domain: '',
};

export default function TeamFindSent() {
  const [searchParams] = useSearchParams();
  const queryString = parseQueryString(searchParams, defaultQueryString);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const amplifyConfig = parseAmplifyConfig(queryString);

  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let emailSent = false;

    if (!emailSent) {
      sendEmail();
    }

    return () => {
      emailSent = true;
    };
  }, []);

  const onClickReenterEmail = () => {
    const params = cloneSearchParams(searchParams);
    params.delete('email');

    navigate(`/teams/find?${params.toString()}`);
  };

  const sendEmail = () => {
    const cupixWorksApiEndpoint =
      amplifyConfig[amplifyConfig.region]?.cupixworksApiEndpoint;
    if (!cupixWorksApiEndpoint) {
      setErrorMessage(t('errors.config_cupixworks_api_endpoint'));
      return;
    }

    if (!isEmailFormat(queryString.email)) {
      setErrorMessage(t('errors.email_invalid'));
      return;
    }

    setLoading(true);
    new CupixWorksApi(cupixWorksApiEndpoint)
      .requestMyTeam(queryString.email)
      .then(() => {
        /* do nothing */
      })
      .catch((error) => setErrorMessage(error))
      .finally(() => setLoading(false));
  };

  return (
    <CPPageBody
      onBackClicked={() => {
        navigate(`/teams/domain?${searchParams.toString()}`);
      }}
    >
      <CardContentTeamFindSent
        email={queryString.email}
        onClickReenterEmail={onClickReenterEmail}
        onClickResendEmail={sendEmail}
        errorMessage={errorMessage}
        loading={loading}
      />
    </CPPageBody>
  );
}
